import style from "./About.module.css";

const About = () => {

    return(
        <div className={style.about}>
            <div className={style.aboutContent}>
                <div className={style.textContainer}>
                    <h2>nosotros</h2>
                    <p>
                        Desde 1990 somos referentes en materiales eléctricos e iluminación en La Plata y todo el país.

                        Nos especializamos en la <span>comercialización y distribución</span> de productos eléctricos de calidad, pensados para el hogar, la construcción, la industria y el gremio.
                    </p>
                    <ul>
                        <li>Variedad y excelencia con marcas líderes</li>
                        <li>Atención y asesoramiento personalizados para cada proyecto</li>
                        <li>Comunicación fluida con clientes y proveedores, basada en la confianza</li>
                        <li>Precios competitivos, con soluciones prácticas y accesibles</li>
                    </ul>
                    <p>
                        Con más de tres décadas de trayectoria, <i>Electroplat</i> mantiene un compromiso firme: brindar un servicio confiable, flexible y cercano, consolidándose como <span>la mejor solución</span> en materiales eléctricos.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;